import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  items: [],
  searchItem: [],
  contents: [],
  storedTracks: [],
  popularArtist: [],
  popularArtistAll: [],
  loading: true,
  // Content lists have their own flag: the artist page loads the artist and its
  // content in parallel, and a load-more must not re-skeleton the identity band.
  contentLoading: false,
  error: null
};
const artistSlice = createSlice({
  name: 'artist',
  initialState,
  reducers: {
    getArtist(state, action) {
      state.loading = true;
      // Drop the previous artist: without this, navigating from one artist to
      // another shows the old name, photo and bio until the new one lands.
      state.items = [];
      state.error = null;
    },
    fetchArtistSuccess(state, action) {
      state.error = null;
      state.items = action.payload;
      state.loading = false;
    },
    getContent(state, action) {
      state.contentLoading = true;
      // A new list (page 1, or a different tab) drops the previous one, so the
      // grid never shows another type's items while the request is in flight.
      if (!action.payload?.append) {
        state.contents = [];
      }
    },
    fetchContentSuccess(state, action) {
      const { append, ...data } = action.payload;
      state.error = null;
      state.contentLoading = false;
      state.contents =
        append && state.contents?.items
          ? { ...data, items: [...state.contents.items, ...(data.items || [])] }
          : data;
      state.storedTracks = [...state.storedTracks, ...(data.items || [])];
    },
    // A failed content list must not leave the grid skeleton spinning forever.
    // It does not set `error`: the artist itself loaded, only one list failed,
    // so the page stays and the grid falls through to its empty state.
    fetchContentFailure(state) {
      state.contentLoading = false;
    },
    topArtist(state, action) {
      state.loading = true;
    },
    topArtistSuccess(state, action) {
      state.loading = false;
      state.popularArtist = action.payload;
    },
    topArtistAll(state, action) {
      state.loading = true;
    },
    topArtistAllSuccess(state, action) {
      state.loading = false;
      state.popularArtistAll = action.payload;
    },
    onFailure(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    getArtistSearch(state, action) {
      state.loading = true;
    },
    getArtistSearchSuccess(state, action) {
      state.loading = false;

      state.searchItem = action.payload;
    },
    getArtistSearchFailure(state, action) {
      state.error = action.payload;
      state.loading = false;
    }
  }
});
export const {
  getArtist,
  fetchArtistSuccess,
  getContent,
  fetchContentSuccess,
  fetchContentFailure,
  topArtist,
  topArtistSuccess,
  topArtistAll,
  topArtistAllSuccess,
  onFailure,
  getArtistSearch,
  getArtistSearchSuccess,
  getArtistSearchFailure
} = artistSlice.actions;
export default artistSlice.reducer;
